import Autocomplete from "@mui/material/Autocomplete"
import Link from "@mui/material/Link"
import TextField from "@mui/material/TextField"
import Typography from "@mui/material/Typography"
import { useState } from "react"

import Column from "../../../common/components/Column"
import { useBaseSelectEmailCampaign } from "./SelectEmailCampaignDialog"
import {
  TemplateGroupTabs,
  useTemplatePickerTab,
} from "./templateGroups"

export default function SelectCampaignAutoComplete({
  selectedCampaign,
  setSelectedCampaign,
  campaignInputValue,
  setCampaignInputValue,
  availableCampaigns,
  setAvailableCampaigns,
  campaignsLoaded,
  campaignsLoading = false,
  onCreateCampaignLinkClicked,
  onCampaignCreated = () => {},
  compact = false,
  hideHelperText = false,
  size = "medium",
  createLinkLabel = "Create one",
  groupByScope = true,
  loadingLabel = "Loading email templates...",
}) {
  const messageHeader =
    availableCampaigns.length === 0
      ? "No campaigns found. Create your first "
      : "Not finding your email template? Create a new template "

  function handleCreateCampaignLinkClicked(e) {
    e.preventDefault()
    onCreateCampaignLinkClicked()
  }

  const { tab, setTab, options } = useTemplatePickerTab(availableCampaigns)

  return (
    <Column sx={{ gap: 1 }}>
      {groupByScope ? (
        <TemplateGroupTabs tab={tab} onChange={setTab} />
      ) : null}
      <Autocomplete
        value={selectedCampaign}
        onChange={(_, newValue) => setSelectedCampaign(newValue)}
        inputValue={campaignInputValue}
        onInputChange={(_, newValue) => setCampaignInputValue(newValue)}
        options={groupByScope ? options : availableCampaigns}
        getOptionLabel={(option) => option.name}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        loading={campaignsLoading}
        disabled={campaignsLoading}
        renderInput={(params) => (
          <TextField
            {...params}
            size={size}
            label="Select template"
            placeholder={
              campaignsLoading
                ? "Loading templates..."
                : compact
                ? "Optional — pick a template or write a reply"
                : undefined
            }
          />
        )}
        fullWidth
      />
      {hideHelperText ? null : compact ? (
        campaignsLoading ? (
          <Typography variant="caption" color="text.secondary">
            {loadingLabel}
          </Typography>
        ) : campaignsLoaded ? (
          <Typography variant="caption" color="text.secondary">
            {availableCampaigns.length === 0
              ? "No templates yet. "
              : "Not finding a template? "}
            <Link href="#" onClick={handleCreateCampaignLinkClicked}>
              {createLinkLabel}
            </Link>
            .
          </Typography>
        ) : null
      ) : campaignsLoading ? (
        <Typography variant="caption" color="text.secondary">
          {loadingLabel}
        </Typography>
      ) : campaignsLoaded ? (
        <Typography variant="body1">
          {messageHeader}
          <Link
            href="#"
            variant="body1"
            onClick={handleCreateCampaignLinkClicked}
          >
            here
          </Link>
          .
        </Typography>
      ) : null}
    </Column>
  )
}

export function useSelectCampaignAutoCompleteState(
  open,
  campaignsAPIURL = "/workflows/api/email/select-campaign/"
) {
  const {
    availableCampaigns,
    setAvailableCampaigns,
    campaignsLoaded,
    campaignsLoading,
  } = useBaseSelectEmailCampaign(open, campaignsAPIURL)
  const [selectedCampaign, setSelectedCampaign] = useState(null)
  const [campaignInputValue, setCampaignInputValue] = useState("")

  return {
    availableCampaigns,
    setAvailableCampaigns,
    campaignsLoaded,
    campaignsLoading,
    selectedCampaign,
    setSelectedCampaign,
    campaignInputValue,
    setCampaignInputValue,
  }
}
